import { library } from '@fortawesome/fontawesome-svg-core'

import {
  faUser as faUserSolid,
  faInfoCircle as faInfoCircleSolid,
} from '@fortawesome/free-solid-svg-icons' // fas
import {
  // faUser as faUserRegular,
  faEdit as faEditRegular,
} from '@fortawesome/free-regular-svg-icons' // far
// import {
//   
// } from '@fortawesome/free-brands-svg-icons'

library.add(
  faUserSolid,
  // faUserRegular,
  faInfoCircleSolid,
  faEditRegular,
)
